import React, { Fragment } from "react";

import { useProfile } from "app/context";
import { DepartmentLink, LocationLink, ProgramLink, ProfileLink } from "app/links";

import ErrorBoundary from "components/common/ErrorBoundary";
import BuildConnection from "components/person/BuildConnection";
import QuickLinks from "components/person/QuickLinks";

import UserCommonalities from "./UserCommonalities";

const PersonCard = ({ person, onChange }) => {
  const { profile } = useProfile();
  const { organization: { isEducational } } = profile;

  return (
    <div className="PersonCard col-xs-12 col-sm-6 col-md-4">
      <div className="people-list-item">
        <ErrorBoundary>
          <div className="col-xs-12 header">
            <ProfileLink user={person} className="link">
              <div
                className="profile-photo"
                style={{ backgroundImage: `url(${person.avatar.mediumUrl})` }}
              />
            </ProfileLink>
          </div>
          <div className="col-xs-12">
            <p className="name">
              <ProfileLink user={person} />
            </p>
            {!isEducational && (<p>{person.title}</p>)}
            {isEducational && (
              <p className="PersonCard--program">
                {person.programs.map((program, index) => (
                  <span key={program.id}>
                    <ProgramLink program={program} />
                    {index !== person.programs.length - 1 && ", "}
                  </span>
                ))}
              </p>
            )}
            {person.id !== profile.id && (
              <>
                <hr />
                <UserCommonalities
                  connection={person.connection}
                  fallback={(
                    <>
                      {person.location && <LocationLink location={person.location} />}
                      {person.departments.map(department => (
                        <Fragment key={department.id}>
                          , <DepartmentLink department={department} />
                        </Fragment>
                      ))}
                    </>
                  )}
                  user={person}
                />
              </>
            )}
          </div>
          {person.id !== profile.id && (
            <div className="col-xs-12 footer">
              <BuildConnection
                profile={person}
              />
            </div>
          )}
        </ErrorBoundary>
      </div>
      <QuickLinks
        user={person}
        profile={profile}
        viewProfile
        onChange={onChange}
        theme="light"
      />
    </div>
  );
};

export default PersonCard;
